var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fapi-form-warning f-px-4 f-py-2 f-relative f-border-white-400 f-border f-text-white f-rounded-t-md f-font-semibold f-bg-orange-500 f--mb-0.5",staticStyle:{"background-color":"#ffa830"},attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }